import createRightComponent from "../../../../helpers/common/CoreInputText/components/Right/fabric";
import { SEARCH_DISPLAY_NAME } from "../../utils/core";

export const Component = createRightComponent(SEARCH_DISPLAY_NAME);
